import { API_CENTRE } from "./config";
import _o2sService from "./_o2sServices";
import { IFilter } from "../models/filters/filter";

import { IBladeFilter } from "../models/filters/bladeFilter";
import { IBladeForm } from "../models/forms/bladeForm";
import { IBladePDTO } from "../models/dtos/bladePDTO";

export default class BladeService extends _o2sService {

    protected static override mainUrl:string = API_CENTRE + "/api/v1/Blades";

    protected static override getUrlFilter<F extends IBladeFilter>(filter?: F):string {
        let url = super.getUrlFilter(filter as IFilter);
        if ( filter != null)
        {
            
            if(filter.bladeProviderId != undefined)
                url += `&BladeProviderId=${filter.bladeProviderId}`;
            if(filter.bladeTypeId != undefined)
                url += `&BladeTypeId=${filter.bladeTypeId}`;
            if(filter.centerId != undefined)
                url += `&CenterId=${filter.centerId}`;
        
        }
        
        return url;
    }

    public static override toDTO(obj:IBladeForm):IBladePDTO {
        const dto = super.toDTO(obj) as IBladePDTO;
        return dto;
    }
}